export const data = {
  people: [
    {
      id: 1,
      avatar: "https://randomuser.me/api/portraits/men/1.jpg",
      name: "John Doe",
      timestamp: "15:30",
      messages: [
        { sender: "John Doe", text: "😅", timestamp: "2023-06-04T10:15:30Z" },
        {
          receiver: "Alice",
          text: "Hi, how are you?",
          timestamp: "2023-06-04T10:20:45Z",
        },
        {
          sender: "John Doe",
          text: "I'm good, thanks!",
          timestamp: "2023-06-04T10:25:15Z",
        },
        {
          receiver: "Alice",
          text: "That's great!",
          timestamp: "2023-06-04T10:30:20Z",
        },
        { sender: "John Doe", text: "😅", timestamp: "2023-06-04T10:15:30Z" },
        {
          receiver: "Alice",
          text: "Hi, how are you?",
          timestamp: "2023-06-04T10:20:45Z",
        },
        {
          sender: "John Doe",
          text: "I'm good, thanks!",
          timestamp: "2023-06-04T10:25:15Z",
        },
      ],
    },
    {
      id: 2,
      avatar: "https://randomuser.me/api/portraits/women/2.jpg",
      name: "Jane Smith",
      timestamp: "11:45",
      messages: [
        {
          sender: "Jane Smith",
          text: "Hi there!",
          timestamp: "2023-06-04T11:45:00Z",
        },
        {
          receiver: "Alice",
          text: "Hey, how's it going?",
          timestamp: "2023-06-04T11:50:30Z",
        },
        {
          sender: "Jane Smith",
          text: "Not bad, thanks!",
          timestamp: "2023-06-04T11:55:15Z",
        },
        {
          receiver: "Alice",
          text: "Good to hear!",
          timestamp: "2023-06-04T12:00:45Z",
        },
        {
          sender: "Jane Smith",
          text: "Hi there!",
          timestamp: "2023-06-04T11:45:00Z",
        },
        {
          receiver: "Alice",
          text: "Hey, how's it going?",
          timestamp: "2023-06-04T11:50:30Z",
        },
        {
          sender: "Jane Smith",
          text: "Not bad, thanks!",
          timestamp: "2023-06-04T11:55:15Z",
        },
      ],
    },
    {
      id: 3,
      avatar: "https://randomuser.me/api/portraits/men/3.jpg",
      name: "Sarah Williams",
      timestamp: "13:20",
      messages: [
        {
          sender: "Sarah Williams",
          text: "Hello!",
          timestamp: "2023-06-04T13:20:00Z",
        },
        {
          receiver: "Alice",
          text: "Hi Sarah, how's your day?",
          timestamp: "2023-06-04T13:25:30Z",
        },
        {
          sender: "Sarah Williams",
          text: "It's going well, thank you!",
          timestamp: "2023-06-04T13:30:15Z",
        },
        {
          receiver: "Alice",
          text: "That's great to hear!",
          timestamp: "2023-06-04T13:35:00Z",
        },
        {
          sender: "Sarah Williams",
          text: "Hello!",
          timestamp: "2023-06-04T13:20:00Z",
        },
        {
          receiver: "Alice",
          text: "Hi Sarah, how's your day?",
          timestamp: "2023-06-04T13:25:30Z",
        },
        {
          sender: "Sarah Williams",
          text: "It's going well, thank you!",
          timestamp: "2023-06-04T13:30:15Z",
        },
      ],
    },
    {
      id: 4,
      avatar: "https://randomuser.me/api/portraits/women/4.jpg",
      name: "Michael Brown",
      timestamp: "7:50",
      messages: [
        {
          sender: "Michael Brown",
          text: "Hey!",
          timestamp: "2023-06-04T14:50:00Z",
        },
        {
          receiver: "Alice",
          text: "Hi Michael, how are you doing?",
          timestamp: "2023-06-04T14:55:30Z",
        },
        {
          sender: "Michael Brown",
          text: "I'm doing great, thanks!",
          timestamp: "2023-06-04T15:00:45Z",
        },
        {
          receiver: "Alice",
          text: "Glad to hear that!",
          timestamp: "2023-06-04T15:05:00Z",
        },
        {
          sender: "Michael Brown",
          text: "Hey!",
          timestamp: "2023-06-04T14:50:00Z",
        },
        {
          receiver: "Alice",
          text: "Hi Michael, how are you doing?",
          timestamp: "2023-06-04T14:55:30Z",
        },
        {
          sender: "Michael Brown",
          text: "I'm doing great, thanks!",
          timestamp: "2023-06-04T15:00:45Z",
        },
      ],
    },
  ],
};
